export const REFERRAL_BONUS_OFFER_PARTNER_NAME = 'Referral Bonus Offer'
export const INSTACART_PARTNER_NAME = 'Instacart'
